/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Sales_Headings_Offerslist1Inputs */

const id_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Penawaran ${i?.title}`)
};

const ms_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tawaran ${i?.title}`)
};

const da_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} Tilbud`)
};

const de_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} Angebote`)
};

const en_us2_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} Offers`)
};

const es_es2_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Juegos de ${i?.title}`)
};

const es_mx2_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ofertas de ${i?.title}`)
};

const fil_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} Offer`)
};

const fr_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offres ${i?.title}`)
};

const it_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offerte ${i?.title}`)
};

const hu_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} ajánlatok`)
};

const nl_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} aanbiedingen`)
};

const no_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} tilbud`)
};

const pl_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferty ${i?.title}`)
};

const pt_br2_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jogos de ${i?.title}`)
};

const pt_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ofertas de ${i?.title}`)
};

const ro_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferte ${i?.title}`)
};

const fi_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tarjoukset ${i?.title}`)
};

const sv_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erbjudanden för ${i?.title}`)
};

const vi_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ưu đãi ${i?.title}`)
};

const tr_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} Teklifleri`)
};

const cs_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nabídky ${i?.title}`)
};

const bg_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Оферти ${i?.title}`)
};

const ru_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предложения ${i?.title}`)
};

const uk_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пропозиції «${i?.title}»`)
};

const ar_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`عروض ${i?.title}`)
};

const hi_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} ऑफ़र`)
};

const th_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ข้อเสนอ ${i?.title}`)
};

const ja_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} オファー`)
};

const zh_cn2_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} 促销目录项`)
};

const zh_hant1_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} 促銷目錄項目`)
};

const ko_sales_headings_offerslist1 = /** @type {(inputs: Sales_Headings_Offerslist1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} 오퍼`)
};

/**
* | output |
* | --- |
* | "{title} Offers" |
*
* @param {Sales_Headings_Offerslist1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_headings_offerslist1 = /** @type {((inputs: Sales_Headings_Offerslist1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Headings_Offerslist1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_headings_offerslist1(inputs)
	if (locale === "ms") return ms_sales_headings_offerslist1(inputs)
	if (locale === "da") return da_sales_headings_offerslist1(inputs)
	if (locale === "de") return de_sales_headings_offerslist1(inputs)
	if (locale === "en-US") return en_us2_sales_headings_offerslist1(inputs)
	if (locale === "es-ES") return es_es2_sales_headings_offerslist1(inputs)
	if (locale === "es-MX") return es_mx2_sales_headings_offerslist1(inputs)
	if (locale === "fil") return fil_sales_headings_offerslist1(inputs)
	if (locale === "fr") return fr_sales_headings_offerslist1(inputs)
	if (locale === "it") return it_sales_headings_offerslist1(inputs)
	if (locale === "hu") return hu_sales_headings_offerslist1(inputs)
	if (locale === "nl") return nl_sales_headings_offerslist1(inputs)
	if (locale === "no") return no_sales_headings_offerslist1(inputs)
	if (locale === "pl") return pl_sales_headings_offerslist1(inputs)
	if (locale === "pt-BR") return pt_br2_sales_headings_offerslist1(inputs)
	if (locale === "pt") return pt_sales_headings_offerslist1(inputs)
	if (locale === "ro") return ro_sales_headings_offerslist1(inputs)
	if (locale === "fi") return fi_sales_headings_offerslist1(inputs)
	if (locale === "sv") return sv_sales_headings_offerslist1(inputs)
	if (locale === "vi") return vi_sales_headings_offerslist1(inputs)
	if (locale === "tr") return tr_sales_headings_offerslist1(inputs)
	if (locale === "cs") return cs_sales_headings_offerslist1(inputs)
	if (locale === "bg") return bg_sales_headings_offerslist1(inputs)
	if (locale === "ru") return ru_sales_headings_offerslist1(inputs)
	if (locale === "uk") return uk_sales_headings_offerslist1(inputs)
	if (locale === "ar") return ar_sales_headings_offerslist1(inputs)
	if (locale === "hi") return hi_sales_headings_offerslist1(inputs)
	if (locale === "th") return th_sales_headings_offerslist1(inputs)
	if (locale === "ja") return ja_sales_headings_offerslist1(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_headings_offerslist1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_headings_offerslist1(inputs)
	return ko_sales_headings_offerslist1(inputs)
});
export { sales_headings_offerslist1 as "sales.headings.offersList" }